import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import getDisplayBrand from '../../../../../utils/getDisplayBrand';
import { useAppContext } from '../../../../AppContext';
import SeekPass from '../../icons/IconSeekPass/IconSeekPass';

import translations from './.vocab';

const SeekPassNudge = () => {
  const { t } = useTranslations(translations);
  const { brand } = useAppContext();

  return (
    <Box
      borderRadius="large"
      background="infoLight"
      padding="medium"
      marginBottom="xsmall"
    >
      <Stack space="xsmall">
        <SeekPass />
        <Text>
          {t('Sign in to share your SEEK Pass results with your SEEK Profile', {
            brand: getDisplayBrand(brand),
          })}
        </Text>
      </Stack>
    </Box>
  );
};

export default SeekPassNudge;
